import ENV from './env'

export const GROCERIES_BACKGROUND_IMAGE = "https://res.cloudinary.com/dgakjrw8j/image/upload/v1667907600/z-dump/groceriesssss-orange_qqasjq.webp"
export const mobRefreshTokenKey = 'mobRefreshToken';
export const defaultRedirectRoute = '/';
export const tokenKey = 'token';
export const siginURL = '/sign-in';
export const OTP_CHECK_URL = '/sign-in/otp-check';
export const EMAIL_CHECK_URL = '/sign-in/email-check';
export const redirecturlQueryParam = 'redirecturl';
export const dev_environment = 'dev';
export const RECIPE_CREATION_TIMEOUT = 60000
export const IMAGE_GENERATION_API = `${ENV.OPEN_AI_CHATBOT}/getImage`;
export const RECIPE_GENERATION_API = `${ENV.OPEN_AI_CHATBOT}/recipe`;
export const INGREDIENT_GENERATION_API = `${ENV.OPEN_AI_CHATBOT}/createIngredient`;
export const MEAL_PLAN_GENERATION_API = `${ENV.OPEN_AI_CHATBOT}/meal_plan`;
export const NOTE_GENERATION_API = `${ENV.OPEN_AI_CHATBOT}/get_note_data`;
export const DEFAULT_RECIPE_CREATION_IMAGE_LINK = 'https://res.cloudinary.com/dgakjrw8j/image/upload/v1699447945/6417730_2_npjpwk.webp';
export const MOBILE_APP = 'mobileApp'
export const USER_CREATED_RECIPE = 'userCreatedRecipe'
export const RECIPE = 'recipe'
export const UP_AI_BRAND_NAME = 'Up⤴️AI'
export const UP_LOGO = 'https://res.cloudinary.com/dgakjrw8j/image/upload/v1716792865/exp-3-assets/purple_icon_jxvyv0.webp'

export const preferenceArray = [
  {
    type: 'nonVeg',
    settingsTitle: 'Everything (Sab kuch!)',
  },
  {
    type: 'egg',
    settingsTitle: 'Eggetarian',
  },
  {
    type: 'veg',
    settingsTitle: 'Vegetarian',
  },
  {
    type: 'vegan',
    settingsTitle: 'Vegan',
  }
]

export const FAVOURITES_ICON_SOURCE = {
  RECIPE_CARD: 'recipeCard',
  RECIPE_BANNER: 'recipeBanner',
  RATINGS_CARD: 'ratingsCard',
}

export const PLATFORM_TYPE = {
  ANDROID: 'Android',
  IOS: 'iOS',
  WEB: 'Web'
}

export const APP_URLS = {
  ANDROID: 'https://play.google.com/store/apps/details?id=com.upliance.android.app',
  IOS: 'https://apps.apple.com/in/app/upliance/id6514318061',
};

export const AMAZON_REVIEW_URL =
  'https://www.amazon.in/review/create-review?asin=B0C9X57D5R';

// App Rating
export const APP_RATING_POSTED_KEY = 'appRatingPosted';
export const APP_RATING_MIN_THRESHOLD = 4;

export const MINI_PLAYER_URL = {
  HOME: '/',
  EXPLORE: '/explore',
  MEAL_PLAN: '/meal-plan',
  ACCOUNT: '/account',
}
